import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import MemberDropdownNew from "../../../../../components/member-dropdown-new/member-dropdown-new";
import TaskGridMemberIcon from "./task-grid-member-icon";
import MemberIconMultipleOwner from "../../../../../components/member-icon-new/member-icon-multi-owner";
import "./task-grid-view-members.scss";
import PropTypes from "prop-types";

const popperConfig = {
  placement: "bottom-end",
  strategy: "fixed",
};

const position = [
  "task-view-members-first-icon",
  "task-view-members-second-icon",
  "task-view-members-third-icon",
  "task-view-members-fourth-icon",
  "task-view-members-fifth-icon",
];

const TaskGridViewMembers = ({
  members,
  groups,
  taskCreator,
  UserID,
  taskType,
  projects,
  isGroup,
  textChange = false,
}) => {
  const [ownerShown, setOwnerShown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [ownerGroup, setOwnerGroup] = useState(null);
  const [MembersShown, setMembersShown] = useState([
    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      // userNameFull: "Z Z",
      User: { Name: "Z Z" }, //-- Change all the names here
      view: false,
    },
  ]);
  const [MembersOnPanel, setMembersOnPanel] = useState([
    {
      approve: false,
      assign: false,
      createdDate: "0001-01-01T00:00:00",
      isActive: false,
      publish: false,
      userID: 0,
      userName: "Z",
      // userNameFull: "Z Z",
      User: { Name: "Z Z" }, //--
      view: false,
    },
  ]);
  const IsMultiOwner = true; 
  const TaskIcon = IsMultiOwner ? MemberIconMultipleOwner : TaskGridMemberIcon;

  useEffect(() => {
    initialFunction();
  }, [members]);

  useEffect(() => {
    setGroups();
  }, [groups]);

  const setGroups = () => {
    let temp = groups?.filter((group) => {
      return group.IsOwner;
    });
    if (temp?.length > 0) {
      setOwnerGroup(temp[0]);
    }
  };

  const FindClassName = (length) => {
    if (length <= 3) {
      return "show-member-panel";
    } else if (length === 4) {
      return "show-member-panel-tasks-1";
    } else {
      return "show-member-panel-tasks";
    }
  };

  const initialFunction = () => {
    let owners = [];
    let nonOwners = [];
  
    if (IsMultiOwner) {
      owners = members?.filter((m) => m.IsOwner) || [];
      nonOwners = members?.filter((m) => !m.IsOwner) || [];
  
      if (groups?.length > 0) {
        const groupList = groups
          .filter((g) => !g.IsOwner)
          .map((g) => ({ User: g, IsGroup: true }));
        nonOwners = nonOwners.concat(groupList);
      }
  
      setOwnerShown(owners.length > 0);
    } else {
      const newUser = members?.find(
        (element) => element.UserId === UserID || element.Id === UserID
      );
  
      if (newUser) {
        owners = [newUser];
        nonOwners = members?.filter(
          (m) => m.UserId !== UserID && m.Id !== UserID
        );
  
        if (groups?.length > 0) {
          const groupList = groups
            .filter((g) => !g.IsOwner)
            .map((g) => ({ User: g, IsGroup: true }));
          nonOwners = nonOwners.concat(groupList);
        }
  
        setOwnerShown(true);
      } else {
        nonOwners = members;
        setOwnerShown(false);
      }
    }
  
    const sortedNonOwners = [...nonOwners].sort((a, b) => {
      const name1 = a.Name ? a.Name.split(" ") : a.User.Name.split(" ");
      const name2 = b.Name ? b.Name.split(" ") : b.User.Name.split(" ");
      if (name1[0] < name2[0]) return -1;
      if (name1[0] > name2[0]) return 1;
      if (name1[1] < name2[1]) return -1;
      if (name1[1] > name2[1]) return 1;
      return 0;
    });
  
    const finalList = [...owners, ...sortedNonOwners];
  
    if (projects) {
      setMembersShown(finalList);
      setMembersOnPanel([...finalList]);
    } else {
      setMembersShown(finalList);
      setMembersOnPanel(finalList);
    }
  };
  
  

  return (
    <div className={`task-view-members ${IsMultiOwner ? "multi-owner" : "single-owner"}`}>
      <Dropdown
        drop={"down"}
        className="removeArrow"
        onMouseLeave={() => setShowDropdown(false)}
        onMouseOver={() => setShowDropdown(true)}
        onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
      >
        <Dropdown.Toggle
          as={"div"}
          className={`task-view-members-toggle`}
          onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
        >
          <>
            {ownerGroup && (
              <div className={`task-view-members-first-icon`}>
                {
                  <TaskIcon
                    member={ownerGroup}
                    type={"user"}
                    isGroup={true}
                    fromTask={true}
                  />
                }
              </div>
            )}
            {ownerGroup && !ownerShown && (
              <div className={`task-view-members-second-icon`}>
                {
                  <TaskIcon
                    member={taskCreator}
                    type={"creator"}
                    isGroup={true}
                    fromTask={true}
                  />
                }
              </div>
            )}
            {MembersShown &&
              MembersShown.slice(0, 4).map((entry, index) => (
                <div
                  key={index}
                  className={
                    ownerGroup
                      ? !ownerShown
                        ? `ownerGroup ${position[index + 2]}`
                        : `ownerGroup ${position[index + 1]}`
                      : `${position[index]}`
                  }
                >
                  {index === 0 && ownerShown && ownerGroup == null ? (
                    <TaskIcon
                      isGroupIcon={entry?.IsGroup}
                      member={entry}
                      type={"user"}
                      fromTask={true}
                    />
                  ) : index === 3 && MembersShown.length - 3 > 0 ? (
                    <TaskIcon
                      member={entry}
                      //isGroupIcon={entry?.IsGroup}
                      extraMembers={MembersShown.length - 3}
                      type={"extra"}
                      fromTask={true}
                    />
                  ) : index === 0 && ownerShown && ownerGroup ? (
                    <div className="creatorMemberContainer">
                      <TaskIcon
                        isGroupIcon={entry?.IsGroup}
                        member={entry}
                        type={"creator"}
                        fromTask={true}
                      />
                    </div>
                  ) : (
                    <TaskIcon
                      isGroupIcon={entry?.IsGroup}
                      member={entry}
                      type={"default"}
                      fromTask={true}
                    />
                  )}
                </div>
              ))}
          </>
        </Dropdown.Toggle>
        <Dropdown.Menu
          popperConfig={popperConfig}
          show={showDropdown}
          style={{ width: `272px` }}
          className={FindClassName(members?.length)}
          drop-dropup-auto="false"
        >
          <div className={"member-dropdown-row-header"}>
            <div className={"member-dropdown-title-text"}>
              {textChange ? "Actionable by" : "View Members/Groups"}
            </div>
          </div>
          <Dropdown.Divider style={{ width: `272px` }}></Dropdown.Divider>

          <div className={"member-dropdown-body-wrapper"}>
            {ownerGroup && (
              <div>
                <MemberDropdownNew
                  member={ownerGroup}
                  taskType={taskType}
                  type={"user"}
                  filter={false}
                  toggleRow={() => {}}
                  selectedMembers={[]}
                  projects={projects}
                  isGroupOwner={true}
                  isMultiOwner={IsMultiOwner}
                ></MemberDropdownNew>
              </div>
            )}
            {ownerGroup && !ownerShown && (
              <div>
                <MemberDropdownNew
                  member={taskCreator}
                  taskType={taskType}
                  type={"creator"}
                  filter={false}
                  toggleRow={() => {}}
                  selectedMembers={[]}
                  projects={projects}
                  isGroupOwner={true}
                  isMultiOwner={IsMultiOwner}
                ></MemberDropdownNew>
              </div>
            )}
            {MembersOnPanel &&
              MembersOnPanel.map((entry, index) =>
                index === 0 && ownerShown && ownerGroup == null ? (
                  <div key={index}>
                    <MemberDropdownNew
                      member={isGroup ? { ...entry, groupID: null } : entry}
                      taskType={taskType}
                      type={"user"}
                      filter={false}
                      toggleRow={() => {}}
                      selectedMembers={[]}
                      projects={projects}
                      isMultiOwner={IsMultiOwner}
                    ></MemberDropdownNew>
                  </div>
                ) : (
                  <div key={index}>
                    <Dropdown.Divider
                      style={{
                        width: `240px`,
                        marginLeft: "15px",
                        "border-bottom": `${
                          (index == 1 && ownerShown && ownerGroup) ||
                          (index == 0 && !ownerShown && ownerGroup)
                            ? "1px solid #8A8886"
                            : ""
                        }`,
                      }}
                    ></Dropdown.Divider>
                    <MemberDropdownNew
                      member={isGroup ? { ...entry, groupID: null } : entry}
                      taskType={taskType}
                      type={index == 0 && ownerShown ? "creator" : ""}
                      filter={false}
                      toggleRow={() => {}}
                      selectedMembers={[]}
                      projects={projects}
                      isGroupIcon={entry?.IsGroup}
                      isMultiOwner={IsMultiOwner}
                    ></MemberDropdownNew>
                  </div>
                )
              )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default TaskGridViewMembers;

TaskGridViewMembers.propTypes = {
  members: PropTypes.array,
  groups: PropTypes.array,
  taskCreator: PropTypes.object,
  UserID: PropTypes.number,
  taskType: PropTypes.string,
  projects: PropTypes.bool,
  isGroup: PropTypes.bool,
  textChange: PropTypes.bool,
};
